import { apiClient } from "../apiClient";

export const getRegistrationStatus = async (serialNumber) => {
    return apiClient.get(
        `/Registration/GetRegistrationStatus?serialNumber=${encodeURIComponent(serialNumber)}`,
        { anonymous: true },
    );
};

export const submitRegistration = async (payload) => {
    return apiClient.post(`/Registration/SubmitRegistration`, payload, { anonymous: true });
};

export const submitSurvey = async (payload) => {
    return apiClient.post(`/Survey/SendSurveyResponse`, payload);
};
